import { useDroppable } from "@dnd-kit/core";

interface IProps {
  dropZoneIndex: number;
  emojiIndex: number | null;
}

export const Circle = ({ dropZoneIndex, emojiIndex }: IProps) => {
  const { isOver, setNodeRef } = useDroppable({
    id: `emoji-dropzone-${dropZoneIndex}`,
    data: {
      index: dropZoneIndex,
    },
  });

  return (
    <div>
      <div
        className="circle"
        style={{
          border: isOver ? "5px solid red" : "2px solid white",
        }}
        ref={setNodeRef}
      >
        {emojiIndex && <img src={`emojis/${emojiIndex}.png`} alt="emoji"></img>}
      </div>
    </div>
  );
};
